import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

class EmailShareButton extends PureComponent {
  render() {
    const { url, children } = this.props;
    return (
      <a className="email-share" href={`mailto:?subject=&amp;body=${url}`}>
        {children}
      </a>
    );
  }
}

EmailShareButton.propTypes = {
  children: PropTypes.node.isRequired,
  url: PropTypes.string.isRequired,
};

export default EmailShareButton;
